import { HTTPLogItem } from '@datadog/datadog-api-client/dist/packages/datadog-api-client-v2';
import type { AppEnv } from '@hc-frontend/core-context';
import { type NextRequest, type NextResponse } from 'next/server';

import type {
  PerformSafeLogRepository,
  RequestContextRepository,
} from '../../domain';
import { getDomainIds } from '../utils/utils';

export type DatadogEdgeAdapterConfig = {
  apiKey: string;
  service: string;
  env: AppEnv;
  version: string;
};

export type DatadogEdgeContextAdapterConfig = {
  request: NextRequest;
  response: NextResponse;
};

HTTPLogItem.attributeTypeMap['additionalProperties'] = {
  baseName: 'additionalProperties',
  type: 'any',
};

export function datadogEdgeContextAdapterFactory({
  request,
  response,
}: DatadogEdgeContextAdapterConfig): RequestContextRepository {
  return async () => {
    const domain = getDomainIds(request.cookies);

    return {
      response: {
        sessionId: response.cookies.get('healthcareSession')?.value,
        userId: response.cookies.get('healthcareUser')?.value,
      },
      request: {
        domainSessionId: domain.domainSessionId,
        domainUserId: domain.domainUserId,
        referrer: request.headers.get('referer') ?? undefined,
        ipAddress: request.ip,
        sessionId: request.cookies.get('healthcareSession')?.value,
        userId: request.cookies.get('healthcareUser')?.value,
        url: request.nextUrl.href,
        userAgent: request.headers.get('user-agent') ?? undefined,
      },
    };
  };
}

export function datadogEdgeAdapterFactory({
  apiKey,
  service,
  env,
  version,
}: DatadogEdgeAdapterConfig): PerformSafeLogRepository {
  let api: any | null = null;
  return async (log) => {
    if (!api) {
      const { client, v2 } = await import('@datadog/datadog-api-client');

      const logClient = client.createConfiguration({
        authMethods: {
          apiKeyAuth: apiKey,
        },
        debug: true,
      });

      api = new v2.LogsApi(logClient);
    }

    await api.submitLog({
      body: [
        {
          ddsource: 'apollo-middleware',
          ddtags: `env:${env},version:${version},source:apollo-middleware`,
          service: service,
          message: log.message,
          additionalProperties: {
            ...log.data,
            level: log.type,
          } as unknown as Record<string, string>,
        },
      ],
    });
  };
}
